<template>
    <div class="huanMain">
        <div class="legend">
            <div class="legend-item flex a-center">
                <div class="mr-12" style="background: #ff0000;width:8px;height: 8px;border-radius: 50%;"></div>
                <div class="a-center">
                    <div class="tit-20 ys-33 B-400 montserRegular">{{infos.lastYearPointNum}} {{yuyan.points}} </div>
                    <div class="tit-14 ys-66 B-300">{{yuyan.Validuntil}} {{infos.lastYear+1}}</div>
                </div>
            </div>
            <div class="legend-item flex a-center">
                <div class="mr-12" style="background: #00aaff;width:8px;height: 8px;border-radius: 50%;"></div>
                <div class="a-center">
                    <div class="tit-20 ys-33 B-400 montserRegular">{{infos.thisYearPointNum}} {{yuyan.points}}</div>
                    <div class="tit-14 ys-66 B-300">{{yuyan.Validuntil}} {{infos.year+1}}</div>
                </div>
            </div>
            <div class="legend-item flex a-center">
                <div class="mr-12" style="background: #cccccc;width:8px;height: 8px;border-radius: 50%;"></div>
                <div class=" a-center">
                    <div class="tit-20 ys-33 B-400 montserRegular">{{infos.totalUsedPointNum}} {{yuyan.points}} </div>
                    <div class="tit-14 ys-66 B-300">{{yuyan.Alreadyredeemed}}</div>
                </div>
            </div>
        </div>
        <div class="rel">
            <div class="chartBox">
                <div class="chart-container" ref="chart"></div>
                <div class="f-10 flex a-center abs" style="color: #82858E;"> 
                    <span class="el-icon-warning-outline f-14 mr-8" style="color: #EB1820;"></span> 
                    {{yuyan.Clickonthe}}
                </div>
            </div>
            <div class="f-14 flex a-center j-center totalText" style="color: #666666;">
                {{yuyan.Totalredeemable}}
                <span class="ys-33 montserRegular">{{infos.pointNum}}</span>
                <span class="iconfont icon-kongxinwenhao f-16 ml-8" style="color: #EB1820;"></span>
            </div>

            <div class="btn-more flex a-center" @click="$dakai('pointsMall')">
                <div class="buzhouanns flex a-center j-center tit-14 ys-0  br-100 montserRegular more1">
                    <el-image fit="contain" class="mr-8" :src="require('@/assets/pc/plus/plus_d7.png')" alt="" />
                    Go to the point mall
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { plusInfo } from '@/api/plus.js';

export default {
    data() {
        return {
            myChart: null
        };
    },
    props: {
        infos: {
            type: [Object, Array],
            default() {
                return {};
            }
        },
		yuyan: {
		    type: [Object, Array],
		    default() {
		        return {};
		    }
		}
    },
    watch: {
        infos(newVal, oldVal) {
            if (newVal) {
                this.initChart();
            }
        }
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.myChart) {
            this.myChart.dispose();
        }
    },
    methods: {
        initChart() {
            if (this.infos) {
                const chartDom = this.$refs.chart;
                this.myChart = echarts.init(chartDom);
                const option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    series: [
                        {
                            name: this.yuyan.points,
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '16',
                                    fontWeight: 'bold'
                                }
                            },
                            data: [
                                {
                                    value: this.infos.lastYearPointNum,
                                    name: this.yuyan.Validuntil+(this.infos.lastYear+1),
                                    itemStyle: {
                                        color: '#ff0000'
                                    }
                                },
                                {
                                    value: this.infos.thisYearPointNum,
                                    name: this.yuyan.Validuntil+(this.infos.year+1),
                                    itemStyle: {
                                        color: '#00aaff'
                                    }
                                },
                                {
                                    value: this.infos.totalUsedPointNum,
                                    name: this.yuyan.Alreadyredeemed,
                                    itemStyle: {
                                        color: '#cccccc'
                                    }
                                }
                            ],
                            itemStyle: {
                                borderRadius: 8,
                                borderColor: '#fff',
                                borderWidth: 2
                            }
                        }
                    ]
                };

                this.myChart.setOption(option);
            }
        },
        handleResize() {
            if (this.myChart) {
                this.myChart.resize();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.huanMain .rel {
    padding-bottom: .5rem;
}

.huanMain .rel .btn-more {
    display: flex;
    align-items: center;
}

.huanMain .rel .totalText {
    flex-wrap: wrap;
    padding: 0 .2rem;
}

::v-deep .buzhouanns {
    cursor: pointer;
    background: linear-gradient(-50deg, #e70a16 0%, #ff785c 100%);
    border-radius: 60px;
    width: auto;
    height: auto;
    display: inline-flex;
    justify-content: center;
    padding: .11rem .25rem;
    margin: .59rem auto 0;

    .el-image {
        width: .21rem;
        height: .21rem;
        min-height: 15px;
        min-width: 15px;
    }
}

.chartBox {
    position: relative;

    .abs {
        bottom: 10%;
        right: 2%;
    }
}

.chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 4rem;
}

.legend {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
}

.legend-item {
    margin: 10px;
}

// 响应式
@media screen and (max-width:767px) {
    .huanMain .rel .chartBox .abs {
        position: relative;
        right: 0;
        padding: 0 .2rem;
    }
}
</style>    